<template>
  <div class="video-meta-container">
    <PreLoaderImage v-if="isPreLoaderShowing" />
    <div v-if="!isPreLoaderShowing && !error">
      <VideoMetaData
        v-if="!isLoading"
        :videoId="video.videoId"
        :imgSrc="video.coverImageUrl"
        :videoLength="video.durationInSeconds"
      />
      <div v-if="isLoading" class="spinner-container">
        <div class="spinner-border" role="status" />
      </div>
    </div>
    <EmptyMessage class="empty-small"
      v-if="!isPreLoaderShowing && error">
      <h5 slot="title" class="title">พบข้อผิดพลาดระหว่างข้อมูลวิดีโอ :(</h5>
      <p>
        โปรดรอสักครู่เพื่อโหลดข้อมูลใหม่ หรือติดต่อ
        <a
          href="mailto:support@byteark.com"
        >support@byteark.com</a>
      </p>
    </EmptyMessage>
  </div>
</template>

<script>
import EmptyMessage from '@/components/EmptyMessage.vue';
import PreLoaderImage from '@/components/PreLoaderImage.vue';
import VideoMetaData from '@/video/VideoMetaData.vue';

export default {
  props: ['error', 'isPreLoaderShowing', 'isLoading', 'video'],
  components: {
    EmptyMessage,
    PreLoaderImage,
    VideoMetaData,
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import '@/assets/scss/themes/components/card.scss';

.video-meta-container {
  .spinner-container {
    height: 200px;
  }
}

@media (max-width: 575.98px) {
  .video-meta-container {
    margin-bottom: $spacer;
  }
}
</style>
